import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {accountsFeature, AccountState} from "../state/accounts.state";
import {AccountsActions, AccountsAPiActions, AccountsChannelActions} from "../state/accounts.actions";
import {AccountModel} from "../models/account.model";
import {Observable, take} from "rxjs";
import {EntitiesFacade} from "../../../commons/angular/classes/entities-facade";

@Injectable()
export class AccountsFacadeService implements EntitiesFacade<AccountModel> {

  public accounts$: Observable<AccountState>;

  constructor(@Inject(Store) private store: Store<AccountState>) {
    this.accounts$ = this.store.select(accountsFeature.selectAccountsState);
  }

  getInfiniteScrollEntities(params?: Object, isSubscribeToChannel?: boolean): void {
    throw new Error('Method not implemented.');
  }

  subscribeToChannels() {
    this.store.dispatch(AccountsChannelActions.subscribe());
  }

  unsubscribeFromChannels() {
    this.store.dispatch(AccountsChannelActions.unsubscribe());
  }

  removeByIds(ids: string[]) {
    this.store.dispatch(AccountsActions.removeAccounts({ids: ids}));
  }

  removeAll() {
    this.store.dispatch(AccountsActions.removeAll());
  }

  setMany(accounts: AccountModel[]) {
    this.store.dispatch(AccountsActions.setAccounts({accounts: accounts}));
  }

  selectOne(id: string) {
    return this.store.select(accountsFeature.selectAccount(id));
  }

  selectByIds(ids: string[]): Observable<AccountModel[]> {
    return this.store.select(accountsFeature.selectAccountsByIds(ids));
  }

  selectAll() {
    return this.store.select(accountsFeature.selectAccounts());
  }

  clearStore() {
    this.store.dispatch(AccountsActions.clearStore());
  }

  //Api Actions on account
  getOne(id: string) {
    this.store.dispatch(AccountsAPiActions.getAccount({id: id}));
  }

  getMany(params?: Object) {
    this.store.dispatch(AccountsAPiActions.getAccounts({params: params}));
  }

  fetchNext(params?: Object) {
    this.store.select(accountsFeature.selectCursor()).pipe(take(1)).subscribe((cursor) => {
      if (!!cursor) {
        this.store.dispatch(AccountsAPiActions.getAccounts({params: params}));
      }
    })
  }

  createOne(account: AccountModel) {
    this.store.dispatch(AccountsAPiActions.createAccount({account: account}));
  }

  editOne(id: string, account: AccountModel) {
    this.store.dispatch(AccountsAPiActions.updateAccount({id: id, account: account}));
  }

  deleteOne(id: string, shouldMask?: boolean) {
    this.store.dispatch(AccountsAPiActions.deleteAccount({id: id, shouldMask: shouldMask}));
  }

  setOne(account: AccountModel): void {
  }

  selectIsLoading(): Observable<boolean> {
    return this.store.select(accountsFeature.selectIsLoading());
  }

  selectInitialized(): Observable<boolean> {
    return this.store.select(accountsFeature.selectInitialized());
  }

  updateMany(entities: AccountModel[]): void {
  }

  updateOne(entity: AccountModel): void {
  }

  selectInfiniteScrollEntities(): Observable<AccountModel[]> {
    return undefined;
  }
}
